module.exports = __webpack_public_path__ + "img/icon-pagination-right.c52e56f2.svg";